import { render, staticRenderFns } from "./dataIdentity.vue?vue&type=template&id=0767f72e"
import script from "./dataIdentity.vue?vue&type=script&lang=js"
export * from "./dataIdentity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports